module.exports = "https://cdn2-fs.clearscore.com/flux/images/12b16dc51d35fbf830ed72186119ed2f.jpg";